<template>
    <div class="product-showcase-feature-wrapper section-space--pt_120">
        <div class="container">
            <div class="row">
                <div class="col-lg-4">
                    <div class="section-title-wrapper section-space--mb_60 wow move-up">
                        <h3 class="font-weight--light text-primary">{{ sectionTitle }}</h3>
                    </div>
                </div>
                <div class="col-lg-8 wow move-up mtn-30">
                    <div v-for="(feature, index) in productFeature" :key="index" class="ht-product-service-box mt-30 px-3">
                        <div class="content-header">
                            <div class="icon">
                                <i :class="feature.icon"></i>
                            </div>
                            <h6 class="heading">{{ feature.title }}</h6>
                        </div>
                        <div class="content-body">
                            <div class="service_text" v-html="feature.desc "></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default{
        name: 'ProductShowcase',
        data(){
            return {
                sectionTitle: 'Vantaggi del contenitore "Safe Box"',
                productFeature: [
                    {
                        icon: 'fal fa-briefcase-medical',
                        title: 'Maggiore sicurezza ingienico - sanitaria ',
                        desc: '• Totale isolamento della singola pietanza dall’ambiente esterno, lungo tutta la filiera.<br/>• Nessun rischio di contaminazioni crociate, con totale garanzia riguardo agli allergeni.<br/>• Totale tracciabilità della pietanza, dalla preparazione alla somministrazione mediante barcode o rfid. ',
                    },
                    {
                        icon: 'fal fa-alarm-clock',
                        title: 'Shelf-life amplificata',
                        desc: '• Notevole estensione della shelf-life delle pietanze, conservate in condizioni di refrigerazione.<br/>• Mantenimento nel tempo delle caratteristiche organolettiche delle pietanze.<br/>• Notevole inibizione dello sviluppo e dell\'attività di batteri aerobi',
                    },
                    {
                        icon: 'fal fa-utensils',
                        title: 'Qualità delle pietanze',
                        desc: '• Migliori caratteristiche organolettiche delle pietanze.<br/>• Preparazioni più semplici, genuine e leggere a ridotto contenuto di grassi e sale.<br/>• Minori perdite di vitamine.<br/>• Esaltazione degli aromi naturali delle materie prime.',
                    }
                ]
            }
        }
    };
</script>